import { useLayoutEffect } from 'react';

import { useUser } from '@/hooks/use-user';
import { isInternalUserAtom } from '@/states/is-internal-user.state';
import { useStore } from 'jotai';

/**
 * Synchronise le type d'utilisateur connecté (`useUser()`) dans `isInternalUserAtom`,
 * que les atomes de blocage/complétion lisent sans pouvoir appeler de hook.
 */
export function useSyncInternalUser(): void {
  const user = useUser();
  const isInternal = !!user?.isInternalUser;
  const store = useStore();

  useLayoutEffect(() => {
    if (store.get(isInternalUserAtom) !== isInternal) {
      store.set(isInternalUserAtom, isInternal);
    }
  }, [store, isInternal]);
}
